<script setup>
import Tooltip from "../../assets/svg/Tooltip.svg"
import TooltipActive from "../../assets/svg/TooltipActive.svg"
import Popper from "vue3-popper";
import {ref} from "vue";

const props = defineProps(["content","title"]);
const isOpen = ref(false);

const toggleAlert = () => {
  isOpen.value = !isOpen.value;
}
</script>

<template>
  <Popper hover
      @open:popper="toggleAlert"
      @close:popper="toggleAlert"
  >
    <template v-if="!isOpen">
      <Tooltip/>
    </template>
    <template v-else>
      <TooltipActive/>
    </template>
    <template #content>
        <div v-if="title"><p class="mb-0 popper-container-text"><strong>{{ title }}</strong></p></div>
        <p class="mb-0 popper-container-text">{{ content }}</p>
    </template>
  </Popper>
</template>

<style>
:root {
  --popper-theme-background-color: #ffffff;
  --popper-theme-background-color-hover: #ffffff;
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-color: #eeeeee;
  --popper-theme-border-radius: 4px;
  --popper-theme-padding: 8px 16px;
  --popper-theme-box-shadow: 0px 2px 15px 0px rgba(76, 75, 84, 0.08);
}
</style>